class UsersProfileController {
	/*@ngInject*/
	constructor(Auth, $state, User, UsersService, $translate, BranchService, $q, $rootScope) {
		this.User = User;
		this.BranchService = BranchService;
		this.UsersService = UsersService;
		this.$rootScope = $rootScope;
		this.model = {};
		this.defaultModel = {};
		this.language = [
			{ value: 'E', label: "English" },
			// { value: 'F', label: 'French' },
			{ value: 'S', label: 'Spanish' }
		];
	}

	isLangSelected(language) {
		return language.value == this.model.languageId;
	}
	toggle(language) {
		this.model.languageId = language.value
	}

	$onInit() {
		this.defaultModel = this.User.getUser()
		this.reset();

		this.UsersService.get(this.defaultModel.id)
		.then((data) => {
			this.rawId = data.id
			this.model.id = data.id
			this.model.firstName = data.firstName
			this.model.lastName = data.lastName
			this.model.email = data.email
			this.model.languageId = data.languageId
			this.model.supervisor = data.supervisor
			this.model.branchId = data.branchId
			this.model.downloadToHHT = data.downloadToHHT
			this.model.isWebUser = !!data.email	
			this.model.isCustomerUser = data.customerUser
		})

		this.BranchService.all(null, 0, 100)
		.then((data) => {
			this.branches = data.results
			.map((branch) => branch.id);
		})
	this.$rootScope.$broadcast('routeChange', '/app/user-profile');
	}

	submit() {
		this.loading = true
		this.UsersService.update(this.model.id, {
			id: this.model.id,
			firstName: this.model.firstName,
			lastName: this.model.lastName,
			email: this.model.email,
			languageId: this.model.languageId,
			supervisor: this.model.supervisor,
			password: this.model.password,
			branchId: this.model.branchId
		})
		.then((data) => {
			this.User.setUser(data);
			this.defaultModel = this.User.getUser();

			this.reset();
		})
		.catch((err) => {
			err.data.errors.map((e) => {
				this.errorMessage += e.message + '<br/>'
			})
		})
		.finally(() => {
			this.loading = false;
		});
	}

	reset() {
		this.model = angular.copy(this.defaultModel);
		this.model.supervisor = !!this.model.supervisor;
		this.cnfPassword = '';
	}
}

export default UsersProfileController;



// WEBPACK FOOTER //
// ./client/app/components/user_profile/user_profile.controller.js